import {Component, Inject, OnInit, Optional} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {IDropdownObject} from 'src/app/interfaces/dropdown-object.interface';
import {IDepartmentDropdowns} from 'src/app/interfaces/settings.iterfaces';
import {DIALOG_DATA} from 'src/app/services/dialog.service';
import {DialogRef} from 'src/app/shared/ui-kits/dialog/dialog-ref';
import {Utils} from 'src/app/shared/utils/utils';

@UntilDestroy()
@Component({
  selector: 'app-position-modal',
  templateUrl: './position-modal.component.html',
  styleUrls: ['./position-modal.component.scss'],
})
export class PositionModalComponent implements OnInit {
  public form!: UntypedFormGroup;
  public isSubDepartment = false;
  public departmentItems: IDropdownObject[] = [];
  public subDepartmentItems: IDropdownObject[] = [];

  public isFieldInvalid = Utils.isFieldInvalid;
  constructor(
    private fb: UntypedFormBuilder,
    private dialogRef: DialogRef,
    @Optional() @Inject(DIALOG_DATA) public data: IDepartmentDropdowns
  ) {}

  ngOnInit(): void {
    this.departmentItems = this.data.Department;
    this.subDepartmentItems = this.data['Sub-Department'];
    this.form = this.fb.group({
      department: new UntypedFormControl(null, [Validators.required]),
      subDepartment: new UntypedFormControl(null),
      positionName: new UntypedFormControl('', [
        Validators.required,
        Validators.maxLength(30),
      ]),
    });

    this.form.controls['department'].valueChanges
      .pipe(untilDestroyed(this))
      .subscribe(value => {
        const subDepartment = this.form.controls['subDepartment'];
        subDepartment.setValue(null);
        this.isSubDepartment = value.name === 'Delivery';
        this.isSubDepartment
          ? subDepartment.addValidators([Validators.required])
          : subDepartment.clearValidators();
        subDepartment.updateValueAndValidity();
      });
  }

  cancel() {
    this.dialogRef.close();
  }

  saveData() {
    if (this.form.invalid) {
      return Utils.validateAllFormFields(this.form);
    }
    const body = {...this.form.value};
    if (body.subDepartment?.name) {
      body.department = body.subDepartment;
    }
    delete body.subDepartment;
    this.dialogRef.close(body);
  }
}
